import {
    GETROLELISTV1_SUCCESS,
    GETROLELISTV1_FAILED,
    RESET_GETROLELISTV1,
    LOADING_GETROLELISTV1,
    NETWORK_ERROR_GETROLELISTV1,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetRoleListV1 = () => {
    return { type: RESET_GETROLELISTV1 };
};

const getRoleListV1 = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETROLELISTV1 });
    await adminServices
        .post("getRoleListV1", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getRoleListV1success(res.data));
                    break;
                default:
                    dispatch(getRoleListV1Failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETROLELISTV1, payload: err });
        });
};
function getRoleListV1success(data) {
    return {
        type: GETROLELISTV1_SUCCESS,
        payload: data,
    };
}
function getRoleListV1Failed(data) {
    return {
        type: GETROLELISTV1_FAILED,
        payload: data,
    };
}

export { resetGetRoleListV1, getRoleListV1 };
